import React, { Component } from 'react'
import { Dimmer, Loader } from 'semantic-ui-react'

class WidgetCardWrapper extends Component {

  render() {
    return (
      <div>
        {this.props.children}
        <Dimmer active={this.props.isLoading} inverted>
          <Loader />
        </Dimmer>
      </div>
    )
  }
}

export default WidgetCardWrapper
